import React from "react";
import Logo from '../elements/Logo';
import PropTypes from "prop-types";

export default class TopLogo extends React.PureComponent {
    render() {
        let { className, isWhite } = this.props;

        return (
            <Logo
                isWhite={isWhite}
                className={`top-logo${className ? ` ${className}` : ''}`}
            />
        );
    }
}

TopLogo.propTypes = {
    isWhite: PropTypes.bool.isRequired,
    className: PropTypes.string,
};
